module.exports = __webpack_public_path__ + "img/angus_niu3.61cd24de.png";